import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.99998 2.66675C8.36817 2.66675 8.66665 2.96522 8.66665 3.33341V12.6667C8.66665 13.0349 8.36817 13.3334 7.99998 13.3334C7.63179 13.3334 7.33331 13.0349 7.33331 12.6667V3.33341C7.33331 2.96522 7.63179 2.66675 7.99998 2.66675Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.66669 7.99992C2.66669 7.63173 2.96516 7.33325 3.33335 7.33325H12.6667C13.0349 7.33325 13.3334 7.63173 13.3334 7.99992C13.3334 8.36811 13.0349 8.66659 12.6667 8.66659H3.33335C2.96516 8.66659 2.66669 8.36811 2.66669 7.99992Z",
		fill: "currentColor"
	})]
});
export default SvgPlus;
